import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function StandardsHighVoltageSafety() {
  return <section id="standards-high-voltage-safety" className="bg-[#0F1B2D] py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="flex flex-col gap-8">
          <div>
            <h2 className="font-default text-3xl md:text-4xl font-bold text-white mb-6">
              Which Standards Apply to Utility Identification?
            </h2>
            <p className="font-sans text-lg text-zinc-300 leading-relaxed">
              Utility and power-generation identification is governed by codes and safety-sign standards distinct from general building wiring. Depending on the installation, these may include the NESC (National Electrical Safety Code) for supply stations and substations, ANSI Z535 for safety signs and high-voltage warning identification, and — for switchgear and electrical rooms — NFPA 70E and NEC 110.16 arc flash labeling. Evermark Industrial Solutions produces identification designed to align with these standards when properly specified.
            </p>
          </div>

          <div className="bg-secondary/40 border-l-4 border-primary p-6 md:p-8 rounded-r-lg shadow-md">
            <p className="font-sans text-zinc-300 leading-relaxed">
              Evermark Industrial Solutions produces the physical nameplates, signs, and labels to the content and format specified for the installation. Which standard applies, what a high-voltage warning sign must say, where it is placed, and whether the identification is adequate are determinations made by the utility, the engineer of record, or a qualified person — not by the label producer. For arc flash labels, Evermark produces the label from the data in the facility's arc flash study and does not perform the study or determine the hazard values. Evermark recommends confirming all safety-identification content and placement with a qualified person.
            </p>
          </div>

          <div className="pt-2">
            <Link to="#" className="inline-flex items-center gap-2 text-primary hover:text-primary/80 font-sans font-semibold text-lg transition-colors group">
              Arc flash labels 
              <ArrowRight className="size-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}